import { Dispatch, SetStateAction, useState } from "react";
import { gql, useMutation } from "@apollo/client";

import Button from "../../Button";
import { Text } from "../../Type";
import ModalActions from "../../../components/ModalActions";
import NotificationBanner from "../../NotificationBanner";
import styles from "./index.module.scss";

const GENERATE_PDF = gql`
  mutation GenerateClientFile($input: GenerateClientFileInput) {
    generateClientFile(input: $input) {
      url
    }
  }
`;

type PropsType = {
  clientFormId: string | undefined;
  setGenerateModalOpen: Dispatch<SetStateAction<boolean>>;
};

const GeneratePdfModal = ({ clientFormId, setGenerateModalOpen }: PropsType) => {
  const [, setBoundaryError] = useState<Error | null>(null);
  const [generatePdf, { loading, error }] = useMutation(
    GENERATE_PDF,
    {
      onCompleted: (data) => {
        window.location.href = data.generateClientFile.url;
        setGenerateModalOpen(false);
      },
      onError: (err) => {
        setBoundaryError(() => {
          throw err;
        });
      }
    }
  );

  const handleClose = () => {
    setGenerateModalOpen(false);
  };

  const handleGenerate = async () => {
    generatePdf({
      variables: {
        input: {
          formId: clientFormId,
        },
      },
    });
  };

  return (
    <>
      {loading &&
        <NotificationBanner
          warning
          title="Please wait..."
          className={styles.warningBanner}
        />
      }
      {error &&
        <NotificationBanner
          error
          title="Error generating PDF. Please try later."
          className={styles.warningBanner}
        />
      }
      <Text>
        This application has not been completed and signed by all parties, would you still like to generate the PDF?
      </Text>
      <br />
      <ModalActions>
        <Button
          primary
          onClick={(handleGenerate)}
          disabled={loading}
        >
          Generate PDF
        </Button>
        <Button
          secondary
          onClick={(handleClose)}
          disabled={loading}
        >
          Close
        </Button>
      </ModalActions>
    </>
  );
}

export default GeneratePdfModal;
